module.exports = __webpack_public_path__ + "img/gustavo_sandoval.1b22d6d5.png";